import React from 'react';

const AccessRestrictedPage: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
      padding: '20px',
    }}>
      <div style={{
        textAlign: 'center',
        maxWidth: '520px',
        padding: '50px 40px',
        borderRadius: '24px',
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 25px 60px rgba(0, 0, 0, 0.3)',
      }}>
        {/* Clock SVG Illustration */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '30px' }}>
        <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
          <circle cx="60" cy="60" r="55" stroke="rgba(255,255,255,0.15)" strokeWidth="2" />
          <circle cx="60" cy="60" r="48" stroke="rgba(99,179,237,0.4)" strokeWidth="3" strokeDasharray="6 4" />
          <circle cx="60" cy="60" r="4" fill="#63b3ed" />
          {/* Hour hand */}
          <line x1="60" y1="60" x2="60" y2="30" stroke="#63b3ed" strokeWidth="4" strokeLinecap="round" />
          {/* Minute hand */}
          <line x1="60" y1="60" x2="82" y2="52" stroke="#a0aec0" strokeWidth="2.5" strokeLinecap="round" />
          {/* Hour markers */}
          {[0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330].map((angle, i) => {
            const rad = (angle * Math.PI) / 180;
            const x1 = 60 + 42 * Math.sin(rad);
            const y1 = 60 - 42 * Math.cos(rad);
            const x2 = 60 + 46 * Math.sin(rad);
            const y2 = 60 - 46 * Math.cos(rad);
            return (
              <line
                key={i}
                x1={x1} y1={y1} x2={x2} y2={y2}
                stroke={i % 3 === 0 ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.2)'}
                strokeWidth={i % 3 === 0 ? 2 : 1}
                strokeLinecap="round"
              />
            );
          })}
          {/* Moon icon */}
          <path
            d="M95 18c-6 0-11.5 3.5-14 8.5a12 12 0 0 0 14 17c-2.5 5-8 8.5-14 8.5-8.8 0-16-7.2-16-16s7.2-16 16-16c5 0 9.5 2.5 12.5 6.5"
            fill="rgba(251, 211, 141, 0.3)"
            stroke="rgba(251, 211, 141, 0.5)"
            strokeWidth="1.5"
            transform="translate(2, -6) scale(0.5)"
          />
        </svg>
        </div>

        <h1 style={{
          color: '#e2e8f0',
          fontSize: '28px',
          fontWeight: 700,
          margin: '0 0 12px',
          letterSpacing: '-0.5px',
        }}>
          Fora do Horário de Acesso
        </h1>

        <p style={{
          color: '#a0aec0',
          fontSize: '16px',
          lineHeight: 1.7,
          margin: '0 0 10px',
        }}>
          O sistema está disponível apenas durante o horário comercial.
        </p>

        <p style={{
          color: '#63b3ed',
          fontSize: '15px',
          margin: '0 0 35px',
          fontWeight: 500,
        }}>
          Tente novamente dentro do horário permitido.
        </p>

        <a
          href="/login"
          style={{
            display: 'inline-block',
            padding: '14px 40px',
            borderRadius: '12px',
            background: 'linear-gradient(135deg, #3182ce 0%, #2b6cb0 100%)',
            color: 'white',
            fontSize: '15px',
            fontWeight: 600,
            textDecoration: 'none',
            transition: 'all 0.2s ease',
            boxShadow: '0 4px 15px rgba(49, 130, 206, 0.3)',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(49, 130, 206, 0.4)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(49, 130, 206, 0.3)';
          }}
        >
          Voltar ao Login
        </a>
      </div>
    </div>
  );
};

export default AccessRestrictedPage;
